import t from '../Translation/Translation';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlus, faTrash, faClone, faDiagramSuccessor, faRotate, faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import "/node_modules/flag-icons/css/flag-icons.min.css";

const icons = {
    "close": <FontAwesomeIcon icon={faXmark} />,
    "refresh": <FontAwesomeIcon icon={faRotate} />,
    "check_draft": <FontAwesomeIcon icon={faCheckDouble} />,
    "new": <FontAwesomeIcon icon={faPlus} />,
    "replace": <FontAwesomeIcon icon={faDiagramSuccessor} />,
    "clone": <FontAwesomeIcon icon={faClone} />,
    "delete": <FontAwesomeIcon icon={faTrash} />,
    "EN" : <span className="fi fi-gb"></span>,
    "ES" : <span className="fi fi-es"></span>,
}

export function lit(key) {
    return (
        <>{icons[key]} {t(key)}</>
    );
}

export function rit(key) {
    return (
        <>{t(key)} {icons[key]}</>
    );
}